import React, { PropsWithChildren, useContext, useMemo } from 'react';
import { CRMConfig, CRMSettings } from './types';
import { useUser } from '../../userContext/UserContext';
import { useCRMSettingsData } from './data/useCRMSettings';


export interface ICRMContext extends CRMConfig {
  canExport: boolean;
  settings: CRMSettings;
  reloadSettings: () => void;
}

const CRMContext = React.createContext<ICRMContext>({
  pagePath: "",
  apiPath: "",
  checkCanExport: () => false,
  canExport: false,
  settings: {
    contact_attributes: [],
  },
  reloadSettings: () => {},
});

export const useCRMContext = () => useContext(CRMContext);


interface Props extends CRMConfig {
}

export const CRMContextProvider = (props: PropsWithChildren<Props>) => {
  const { children, ...config } = props;
  const { user } = useUser();

  const settings = useCRMSettingsData(config.apiPath);
  
  const data = useMemo(() => {
    const checkCanExport = config.checkCanExport || (() => false);
    let canExport = false;
    try {
      canExport = checkCanExport(user);
    } catch(e) { }

    return {
      ...config,
      canExport,
      settings: settings.data,
      reloadSettings: settings.reload,
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.apiPath, config.pagePath, settings.data, user]);


  return (
    <CRMContext.Provider value={data}>
        {children}
    </CRMContext.Provider>
  );
}
